import { render, staticRenderFns } from "./TeacherFormModal.vue?vue&type=template&id=ad5d1bb6&lang=pug&"
import script from "./TeacherFormModal.vue?vue&type=script&lang=js&"
export * from "./TeacherFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports